module.exports = __webpack_public_path__ + "static/banner-8d2e6fe021538bacd2ae091609eefa8d.jpg";